module.exports = __webpack_public_path__ + "img/layout_bottom_5.b4d7b633.png";